import { useInitializeTimeZonePreference } from 'lib/hooks/useInitializeTimeZonePreference/useInitializeTimeZonePreference'

interface TimeZonePreferenceInitializerProps {
  profileId: string
}

export const TimeZonePreferenceInitializer: React.FC<TimeZonePreferenceInitializerProps> = ({ profileId }) => {
  useInitializeTimeZonePreference(profileId)

  return null
}
